module.exports = __webpack_public_path__ + "static/img/18.fd73f8a4.png";